// Ai đang phải làm ở mỗi đơn — để creator nhìn là biết việc nào của mình, việc nào đang chờ đối tác (sếp góp ý 14/10:
// trang cũ chia theo loại đơn nên không rõ lúc nào là việc của mình).
export type BrandTurn = 'mine' | 'partner';

export const TURN_LABEL: Record<BrandTurn, string> = {
  mine: 'Đến lượt bạn',
  partner: 'Chờ đối tác',
};

/** Nhiệm vụ brief / đơn nhận đề xuất: đang soạn, cần sửa, chờ bấm đăng là việc của creator; đã nộp là chờ người đặt duyệt. */
export const taskTurn = (status: string | null | undefined): BrandTurn | null => {
  if (status === 'Working' || status === 'RevisionRequested' || status === 'AwaitingPublish') return 'mine';
  if (status === 'Submitted') return 'partner';
  return null;
};

/** Đơn ứng tuyển / đề xuất creator đã gửi: còn chờ thì là việc của đối tác. */
export const sentRequestTurn = (status: string | null | undefined): BrandTurn | null =>
  status === 'Pending' ? 'partner' : null;
